import Table, { TableOpts, TableRowBase } from './table-ts.ts'

export default class TableShim<Data extends TableRowBase> extends Table<Data> {
    constructor(tableOpts: TableOpts<Data, Table<Data>>) {
        if (typeof tableOpts.showRank !== 'boolean') {
            // eslint-disable-next-line no-param-reassign
            tableOpts.showRank = false
        }
        if (tableOpts.sortClass === undefined) {
            // eslint-disable-next-line no-param-reassign
            tableOpts.sortClass = ''
        }

        if (tableOpts.pagination === undefined) {
            // eslint-disable-next-line no-param-reassign
            tableOpts.pagination = { enabled: false }
        }

        if (tableOpts.search === undefined) {
            // eslint-disable-next-line no-param-reassign
            tableOpts.search = { enabled: false }
        }

        super(tableOpts)
    }
}
